<template>
  <div>
    <span
      v-for="(icon, index) in icons"
      :key="index"
      class="mr-2 p-2"
      v-bind:class="[{ 'selected': icon === currentValue }]"
    >
      <font-awesome-icon
        size="lg"
        :icon="icon"
        @click="iconClicked(icon)"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: 'IconPicker',
  data() {
    return {
      icons: [
        'search', 'map', 'home', 'star', 'coffee',
      ],
      currentValue: this.value,
    };
  },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    content: {
      get() { return this.value; },
      set(newValue) {
        this.currentValue = newValue;
        this.$emit('input', this.currentValue);
      },
    },
  },
  methods: {
    iconClicked(name) {
      this.content = name;
    },
  },
};
</script>

<style scoped>
span {
  cursor: pointer;
}
.selected {
  background-color: #9a9a9a;
}
</style>
